<div class="container">
    <div class="row">
        <div class="col-sm-12 title">
            <h1 class="main-heading">{{ 'rpe.vista-nuevo-vinculo.title' | translate }}</h1>
        </div>
    </div>
    <div class="row">
        <rpe-entity-rol-form-container></rpe-entity-rol-form-container>
    </div>
</div>

